import { DoneOutlineIcon, Tag, Text } from '@beef/ui-kit';
import { isPlainObject } from '@beef/utils';
import classNames from 'classnames/bind';
import React, { memo } from 'react';
import { TeaserVideo } from "../Media/TeaserVideo";
import { Picture } from "../Picture";
import { useIsMobileDimension } from "../../hooks/useGetDimensionGroup";
import { ActionButton } from "./ActionButton";
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
export var TeaserBanner = /*#__PURE__*/memo(function (_ref) {
  var title = _ref.title,
    _ref$titleColor = _ref.titleColor,
    titleColor = _ref$titleColor === void 0 ? 'grey95' : _ref$titleColor,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === void 0 ? 'grey60' : _ref$textColor,
    text = _ref.text,
    button = _ref.button,
    backgroundColor = _ref.backgroundColor,
    img = _ref.img,
    withDivider = _ref.withDivider,
    isBackgroundImage = _ref.isBackgroundImage,
    detailsNode = _ref.detailsNode,
    children = _ref.children,
    video = _ref.video,
    backgroundSettings = _ref.backgroundSettings;
  var isMobile = useIsMobileDimension();
  var isVideo = !!(video !== null && video !== void 0 && video.src && !(img !== null && img !== void 0 && img.src));
  var _ref2 = backgroundSettings || {},
    hasGradient = _ref2.hasGradient,
    tagSettings = _ref2.tagSettings,
    statusSettings = _ref2.statusSettings;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('content-wrapper', {
      divider: withDivider
    }),
    style: {
      backgroundColor: backgroundColor
    },
    "data-t-id": "components-TeaserBanner"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('content'),
    style: isMobile ? {
      backgroundColor: backgroundColor
    } : undefined
  }, isPlainObject(tagSettings) && /*#__PURE__*/React.createElement("div", {
    className: cn('tag')
  }, /*#__PURE__*/React.createElement(Tag, tagSettings)), detailsNode || /*#__PURE__*/React.createElement("div", {
    className: cn('details', {
      'details-divider': withDivider
    })
  }, isPlainObject(statusSettings) && /*#__PURE__*/React.createElement("div", {
    className: cn('status')
  }, /*#__PURE__*/React.createElement(DoneOutlineIcon, null), /*#__PURE__*/React.createElement(Text, {
    size: "size5-m"
  }, statusSettings.text)), title && /*#__PURE__*/React.createElement(Text, {
    color: titleColor,
    size: "size0-b",
    tagType: "h1"
  }, title), text && /*#__PURE__*/React.createElement("div", {
    className: cn('details__text')
  }, /*#__PURE__*/React.createElement(Text, {
    color: textColor,
    size: "size4-r"
  }, text)), children, (button === null || button === void 0 ? void 0 : button.text) && /*#__PURE__*/React.createElement(ActionButton, {
    button: button,
    isMobile: isMobile
  })), /*#__PURE__*/React.createElement("div", {
    className: cn('details__img', {
      'img--background': isBackgroundImage,
      'details__img--wide': isVideo,
      'details__img--has-gradient': hasGradient
    }),
    style: {
      backgroundColor: backgroundColor
    }
  }, (img === null || img === void 0 ? void 0 : img.src) && /*#__PURE__*/React.createElement(Picture, {
    alt: img.alt,
    className: cn('img'),
    fallbackSrc: img.fallbackSrc,
    lazy: true,
    onError: img.onError,
    source: img.source,
    src: img.src,
    title: img.title
  }), isVideo && /*#__PURE__*/React.createElement(TeaserVideo, {
    className: cn('video'),
    loop: video.loop,
    poster: video.poster,
    source: video.source,
    src: video.src
  }))));
});
TeaserBanner.displayName = TeaserBanner.name;